import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useLocaleStore } from '@/shared/store/localeStore'

import { getHelpCategoryByKey, helpPath, type HelpCategoryKey } from '../data/helpCategories'

interface HelpRelatedLinksProps {
  currentKey: HelpCategoryKey
}

export function HelpRelatedLinks({ currentKey }: HelpRelatedLinksProps) {
  const { t } = useTranslation()
  const locale = useLocaleStore((s) => s.locale)
  const current = getHelpCategoryByKey(currentKey)
  if (!current) return null
  const related = current.relatedKeys
    .map((key) => getHelpCategoryByKey(key))
    .filter((c): c is NonNullable<typeof c> => Boolean(c))

  return (
    <section className="my-10 border-t-2 border-foreground/15 pt-6">
      <p className="mb-4 font-brutal text-xs font-bold uppercase tracking-[0.18em] text-muted-foreground">
        {t('help.common.relatedHeading')}
      </p>
      <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {related.map((cat) => (
          <li key={cat.key}>
            <Link
              to={helpPath(cat.key, locale)}
              className="brutal-sm flex items-center justify-between gap-3 rounded-md bg-card px-4 py-3 font-display text-base font-bold transition-transform hover:-translate-y-0.5"
            >
              <span>{t(cat.titleKey)}</span>
              <span aria-hidden>→</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}
